module.exports = __webpack_public_path__ + "img/pass.61f758ce.jpg";